import React, { useState, useEffect } from "react";
import { usePrevious } from "../../components/sports/glo/brackets/common";

// generic 
import { ScoreContainer as GenScoreContainer } from "components/sports/glo/scores/generic";
import { ScoreWinCheckContainer as GenScoreWinCheckContainer } from "components/sports/glo/scores/generic";

// sport related
import { ScoreContainer as BdmScoreContainer } from "components/sports/glo/scores/bdm";
import { ScoreContainer as ClbScoreContainer } from "components/sports/glo/scores/clb";
import { ScoreContainer as CslScoreContainer } from "components/sports/glo/scores/csl";
import { ScoreContainer as JudScoreContainer } from "components/sports/glo/scores/jud";
import { ScoreContainer as SrfScoreContainer } from "components/sports/glo/scores/srf";
import { ScoreContainer as TenScoreContainer } from "components/sports/glo/scores/ten";
import { ScoreContainer as BoxScoreContainer } from "components/sports/glo/scores/box";
import { ScoreContainer as KikScoreContainer } from "components/sports/glo/scores/kik";
import { ScoreContainer as MtiScoreContainer } from "components/sports/glo/scores/mti";
import { ScoreContainer as KteScoreContainer } from "components/sports/glo/scores/kte";
import { ScoreContainer as FblScoreContainer } from "components/sports/glo/scores/fbl";


export function Score(props) {

  const resultObj = props?.resultJson ? JSON.parse(props?.resultJson) : {};
  const {discipline, resultStatus, type} = props
  const [isLoading, setLoading] = useState(false);
  const result = resultObj?.result;
  const prevResult = usePrevious({ result });


  function loadingTime() {
    return new Promise((resolve) => setTimeout(resolve, 4000));
  }

  useEffect(() => {
    if (isLoading) {
      loadingTime().then(() => {
        setLoading(false);
      });
    }
  }, [isLoading]);


  useEffect(() => {
    if (prevResult && (prevResult !== result)) {
      setLoading(true)
    }
  }, [result])

  const ScoreContainer = getScoreContainer(discipline)

  return (
    <ScoreContainer resultObj={resultObj} resultStatus={resultStatus} type={type}/>
  )
}

const getScoreContainer = (discipline) => {
  switch (discipline) {
    case 'BDM':
      return BdmScoreContainer
    case 'BSC':
      return GenScoreWinCheckContainer
    case 'CLB':
      return ClbScoreContainer
    case 'CSL':
      return CslScoreContainer
    case 'FBB':
    case 'FBL':
      return FblScoreContainer
    case 'JUD':
      return JudScoreContainer
    case 'KTE':
      return KteScoreContainer
    case 'SRF':
      return SrfScoreContainer
    case 'TEN':
      return TenScoreContainer
    case 'TTE':
      return GenScoreWinCheckContainer
    case 'BOX':
      return BoxScoreContainer
    case 'KIK':
      return KikScoreContainer
    case 'MTI':
      return MtiScoreContainer
    default:
      return GenScoreContainer
  }
}